import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../lib/api";
import CategoryBanner from "../components/CategoryBanner";
import { AlertTriangle, ArrowRight, Clock, BadgeCheck } from "lucide-react";

const DIFF_COLORS = {
  débutant: "border-success/40 text-success",
  intermédiaire: "border-warning/40 text-warning",
  avancé: "border-gold-300 text-gold-700",
};

export default function CategoryDetail() {
  const { slug } = useParams();
  const [cat, setCat] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    api.get(`/categories/${slug}`).then(r => setCat(r.data)).catch(() => setErr("Catégorie introuvable"));
  }, [slug]);

  if (err) return <div className="max-w-3xl mx-auto p-10 text-center text-danger">{err}</div>;
  if (!cat) return <div className="max-w-3xl mx-auto p-10 text-muted2 text-center font-mono text-sm">Chargement…</div>;

  return (
    <div className="max-w-6xl mx-auto px-6 py-12" data-testid="category-detail-page">
      <CategoryBanner
        imageUrl={cat.image_url}
        kicker="Catégorie"
        title={cat.name}
        description={cat.description}
      />

      {cat.disclaimer && (
        <div
          className={`rounded-xl border p-5 mb-10 flex gap-3 ${
            cat.disclaimer_type === "danger"
              ? "bg-danger/10 border-danger/40 text-danger"
              : "bg-warning/10 border-warning/40 text-warning"
          }`}
          data-testid="category-disclaimer"
        >
          <AlertTriangle className="w-5 h-5 flex-shrink-0 mt-0.5" />
          <p className="text-sm leading-relaxed">{cat.disclaimer}</p>
        </div>
      )}

      <div className="flex items-baseline justify-between mb-6">
        <h2 className="font-display text-3xl text-ink-900">Certifications disponibles</h2>
        <span className="text-sm text-muted2 font-mono">{cat.certifications.length} formations</span>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {cat.certifications.map((c) => (
          <Link
            key={c.id}
            to={`/certifications/${c.slug}`}
            className="glass rounded-2xl p-6 hover:shadow-gold transition-all group"
            data-testid={`certification-card-${c.slug}`}
          >
            <div className="flex items-start justify-between gap-3 mb-3">
              <h3 className="font-display text-xl text-ink-900 group-hover:text-gold-700-700 transition-colors">{c.title}</h3>
              <span className={`text-[10px] uppercase tracking-widest font-mono px-2 py-1 rounded-full border whitespace-nowrap ${DIFF_COLORS[c.difficulty_level]}`}>
                {c.difficulty_level}
              </span>
            </div>
            <p className="text-sm text-muted2 line-clamp-2 mb-4">{c.description}</p>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3 text-xs text-muted2">
                <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {c.estimated_duration_hours}h</span>
                <span className="flex items-center gap-1"><BadgeCheck className="w-3.5 h-3.5 text-gold-700" /> Certificat PDF</span>
              </div>
              <div className="flex items-center gap-3">
                <span className="font-display text-2xl text-gold-700-gradient">{c.price_euros}€</span>
                <ArrowRight className="w-4 h-4 text-gold-700 group-hover:translate-x-1 transition-transform" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
